import { DateInput, NumberInput, TextInput } from '@core/components/Inputs';
import { Grid, Tooltip } from '@material-ui/core';
import { PessoaFisicaAutocomplete } from 'app/main/pessoa';
import React from 'react';

const VendedorDadosGeraisPessoaFisica = ({
  id,
  name,
  values: { pessoaFisica, comissao, inscricaoMunicipal },
  errors = {},
  touched = {},
  onChange,
  onBlur,
  fetchPapel,
  possuiVinculo,
}) => {
  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <PessoaFisicaAutocomplete
          id={`${id}.cpf`}
          name={`${name}.cpf`}
          value={pessoaFisica?.cpf}
          touched={touched?.pessoaFisica?.cpf}
          error={errors?.pessoaFisica?.cpf}
          onBlur={onBlur}
          onChange={onChange}
          papel="vendedor"
          fetchPapel={fetchPapel}
          disabled={possuiVinculo && pessoaFisica?.cpf}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
        <TextInput
          id={`${id}.identidade`}
          name={`${name}.identidade`}
          onChange={onChange}
          onBlur={onBlur}
          value={pessoaFisica.identidade}
          error={errors?.pessoaFisica?.identidade}
          touched={touched?.pessoaFisica?.identidade}
          fullWidth
          variant="outlined"
          label="Identidade"
          maxLength={10}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
        <DateInput
          fullWidth
          disableFuture
          id={`${id}.dataNascimento`}
          name={`${name}.dataNascimento`}
          label="Data de nascimento"
          value={pessoaFisica.dataNascimento}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
        <Tooltip placement="top-start" title="Percentual de comissão padrão do vendedor">
          <div>
            <NumberInput
              label="Comissão (%)"
              id="comissao"
              decimalScale={8}
              decimalSeparator=","
              allowNegative={false}
              isAllowed={(values) => {
                return !values.floatValue || values.floatValue <= 100;
              }}
              value={comissao}
              onChange={onChange}
              onBlur={onBlur}
            />
          </div>
        </Tooltip>
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
        <TextInput
          id={`${id}.identificadorEstrangeiro`}
          name={`${name}.identificadorEstrangeiro`}
          onChange={onChange}
          onBlur={onBlur}
          value={pessoaFisica.identificadorEstrangeiro}
          error={errors?.pessoaFisica?.identificadorEstrangeiro}
          touched={touched?.pessoaFisica?.identificadorEstrangeiro}
          fullWidth
          variant="outlined"
          label="Identificador estrangeiro"
          maxLength={15}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextInput
          id="pessoa.inscricaoMunicipal"
          name="pessoa.inscricaoMunicipal"
          onChange={onChange}
          onBlur={onBlur}
          value={inscricaoMunicipal}
          error={errors?.inscricaoMunicipal}
          touched={touched?.inscricaoMunicipal}
          fullWidth
          variant="outlined"
          label="Inscrição municipal"
          maxLength={20}
        />
      </Grid>
    </>
  );
};

export default VendedorDadosGeraisPessoaFisica;
